import { render, staticRenderFns } from "./Lgx335766951898906624.vue?vue&type=template&id=d5c976c4&scoped=true&"
import script from "./Lgx335766951898906624.vue?vue&type=script&lang=js&"
export * from "./Lgx335766951898906624.vue?vue&type=script&lang=js&"
import style0 from "./Lgx335766951898906624.vue?vue&type=style&index=0&id=d5c976c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c976c4",
  null
  
)

export default component.exports